export default "__VITE_ASSET__DhFQADk8__"